import React from 'react'
import { Link } from 'react-router-dom'
import Flex from 'antd/lib/flex'
import Typography from 'antd/lib/typography'
import { useTheme } from '../ThemeProvider/ThemeProvider'
import bg from '../../../assets/images/verificationBanner.png'
import styles from './UserBlocked.module.scss'

const UserBlocked = () => {
  const { themeMode } = useTheme() || {}

  return (
    <Flex wrap='wrap' className={`${styles.container} ${styles[themeMode]}`}>
      <Flex flex='1 1 50%' className={styles.imgWrapper}>
        <img className={styles.image} src={bg} alt='Verify Email' />
        <Typography.Text className={styles.text}>
          Account
          <br />
          <span>Blocked</span>
        </Typography.Text>
      </Flex>
      <Flex flex='1 1 50%' className={styles.contentWrapper} vertical justify='space-between'>
        <Flex className={`${styles.textWrapper} ${styles[themeMode]}`} vertical>
          <Typography.Title className={styles.title}>
            Your Account has been blocked!
          </Typography.Title>
          <Typography.Paragraph className={styles.paragraph}>
            Your account has been blocked due to a violation of our <Link target='_blank' to='https://www.nolanai.app/terms-of-service'>terms of service</Link>.
            <br />
            <br />
            If you believe this is an error or have any questions, please contact our support team for further
            assistance.
            <strong> <Link to='mailto:support@nolanai.app'>support@finalbitai.com</Link></strong>
          </Typography.Paragraph>
        </Flex>
      </Flex>
    </Flex>
  )
}

export default UserBlocked
